import * as actions from "./themeType";
import { ThemeData } from "./themeType";

export const requestTheme = (propcode?: string): actions.ThemeRequest => ({
  type: actions.THEME_REQUEST,
  payload: { propcode },
});

export const setThemeSuccess = (data: ThemeData): actions.ThemeSuccess => ({
  type: actions.THEME_SUCCESS,
  payload: data,
});

export const setThemeFailure = (message: string): actions.ThemeFailure => ({
  type: actions.THEME_FAILURE,
  payload: message,
});

export const setTheme = (data: ThemeData): actions.SetTheme => ({
  type: actions.SET_THEME,
  payload: data,
});

export const updateTheme = (data: ThemeData): actions.UpdateTheme => ({
  type: actions.UPDATE_THEME,
  payload: data,
});

export const updateThemeTemplate = (
  data: ThemeData
): actions.UpdateThemeTemplate => ({
  type: actions.UPDATE_THEME_TEMPLATE,
  payload: data,
});

export const saveThemeRequest = (
  propCode: string,
  themeData: ThemeData
): actions.SaveThemeRequest => ({
  type: actions.SAVE_THEME_REQUEST,
  payload: { propCode, themeData },
});

export const saveThemeSuccess = (): actions.SaveThemeSuccess => ({
  type: actions.SAVE_THEME_SUCCESS,
});

export const saveThemeFailure = (message: string): actions.SaveThemeFailure => ({
  type: actions.SAVE_THEME_FAILURE,
  payload: message,
});
